<!-- NOTE: モバイルアプリでは、flutterが非対応のためjsの`confirm`や`alert`が起動しないので確認モダルを自作する -->
<!-- ref. https://github.com/over-drive/bodoge.hoobby.net/issues/3372 -->
<template lang="pug">
div.dialog--overlay(v-show="visibleDialog")
  div.dialog--overlay-wrapper
    div.dialog--overlay-wrapper-text
      | {{message}}
    div.dialog--overlay-wrapper-button
      span.btn.btn-primary.dialog--overlay-wrapper-button-submit(@click="executeConfirmation") OK
      span.btn.btn-default.dialog--overlay-wrapper-button-cancel(@click="hideDialog") キャンセル
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: () => ({})
    },
    visibleDialog: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    hideDialog: function() {
      this.$emit('hide-dialog');
    },
    executeConfirmation: function() {
      this.$emit('execute-confirmation');
      this.hideDialog();
    }
  }
};
</script>
